<template>
   <div>   
           <div class="row">
            <div class="column small-12">
             <input type="radio" name="mode"  v-bind:checked="mode === 'lab-supplied-frame'"  v-on:change="toggleMode('lab-supplied-frame')"> I want to choose FREE frames
            </div>
        </div>
         
        <div class="row">
            <div class="column small-12">
             <input type="radio" name="mode"  v-bind:checked="mode === 'frame-to-come'"  v-on:change="toggleMode('frame-to-come')"> I am sending in my frames
            </div>
        </div>  
     
   </div>

</template>
<script>
export default {
  model: {
    prop: "mode",
    event: "change"
  },
  props: {
    mode: String
  },
  methods: {
    toggleMode(newValue) {
      this.$emit("change", newValue);
    }
  }
};
</script>
